import(/* webpackMode: "eager" */ "/vercel/path0/src/App.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/Home.tsx");
